import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import CalenderImg from '../../assets/images/calender.png';
import { useNavigate } from 'react-router-dom';
import { Pagination, Input, Form, Select, Row, Col, Space, Spin, message, Collapse } from 'antd';
//Collapse
import { CaretRightOutlined, CaretDownOutlined, SettingOutlined, CodeSandboxCircleFilled } from '@ant-design/icons';
import moment from 'moment';
//Collapse End
// import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// import { EditTwoTone, BranchesOutlined } from '@ant-design/icons';
import getHeaders from '../../utils/authHeaders';
// import ListinngCard from '../../layouts/ListingCard';
import { dateConverter } from '../../utils/utcDateConversionCommon';

import EcommerceDashboardCard from '../../layouts/EcommerceDashboardCard';
import NoDataFound from '../../layouts/NoDataFound';
// import MainOrderViewModal from './MainOrderViewModal';
// import SubOrderViewModal from './SubOrderViewModal';
// import DashboardMainOrderModal from './DashboardMainOrderModal';
// import EcomDashboardHeader from './EcomDashboardHeader';
// import EcommerceCards from './EcommerceCards';
// import { SearchBar } from '../../layouts/SearchBar';
import LoaderImage from '../LoaderImage';
const { TextArea } = Input;
import { durationSelection, onChangeMethod } from '../../utils/SortingUtils';
import { localDate } from '../../lib/localDateConvertor';
// import EcomDashboardHeader from '../EcomOrders/EcomDashboardHeader';
import EcommerceCards from '../Ecom Orders/EcommerceCards';
import { SearchBar } from '../../layouts/SearchBar';
import MainOrderViewModal from '../Ecom Orders/MainOrderViewModal';
import SubOrderViewModal from '../Ecom Orders/SubOrderViewModal';
import SubsDashboardCard from './SubsDashboardCard';
import ressponse from './ressponse';
import SubsMainModal from './SubsMainModal';
import EcomDashboardHeader from '../Ecom Orders/EcomDashboardHeader';
// import IsMainModal from './IsMainModal';

const SubsDashboard = () => {
//   const { RangePicker } = DatePicker;
  const [activeIndex, setActiveIndex] = useState(1);
  const [cancelShow, setCancelShow] = useState(false);
  const [editbtn, setEditBtn] = useState('none');
  const [pageSize, setPageSize] = useState(10);
  const [fetchPartners, setFetchPartners] = useState([]);
  const [subOrderObj, setSubOrderObj] = useState({});
  const [pagesCount, setPagesCount] = useState(0);
  const [searchShow, setSearchShow] = useState({});
  const [renderList, setRenderList] = useState([]);
  const [tableShow, setTableShow] = useState(true);
  const [isCustomerRequest, setIsCustomerRequest] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
const [ismainView, setismainView] = useState(false);
  const [err, setErr] = useState('');
  const [tableHeaders, setTableHeaders] = useState([]);
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState([]);
  const [cancelData, setCancelData] = useState({});
  const [orderCancelResp, setOrderCancelResp] = useState();
  const [cancelStatus, setCancelStatus] = useState(false);
  const [mainModalData, setmainModalData] = useState()
  const [reciveBackData, setReciveBackData] = useState({});
  const [reciveBackResp, setReciveBackResp] = useState();
  const [reciveBackStatus, setReciveBackStatus] = useState(false);
  const [reciveBackShow, setReciveBackShow] = useState(false);
  const [isRecivedBack, setIsReciveBack] = useState(false);
  const [filterObj, setfilterObj] = useState({});
  const [durationFreq, setdurationFreq] = useState([]);
  const [orderByObj, setorderByObj] = useState([]);
  const [resendOrderData, setResendOrderData] = useState({});
  const [resendOrderResp, setResendOrderResp] = useState();
  const [resendOrderStatus, setResendOrderStatus] = useState(false);
  const [resendOrderShow, setResendOrderShow] = useState(false);

  const [missingItem, setMissingItem] = useState(false);

  const [stockOutResp, setStockOutResp] = useState([]);
  const [dispatchData, setDispatchData] = useState([]);
  const [dispatchShow, setDispatchShow] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [singleOrderOBj, setSingleOrderObj] = useState({});
  const [showSingleOrder, setShowSingleOrder] = useState(false);
  const [loader, setLoader] = useState(false);
  const[newFilter,setnewFilter]=useState({})

  const [singleMainOrderOBj, setSingleMainOrderObj] = useState({});
  const [showSingleMainOrder, setShowSingleMainOrder] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [adminComment, setAdminComment] = useState('');
  const [orderDateFrom, setorderDateFrom] = useState('');
  const [orderDateTo, setorderDateTo] = useState('');
const [isChange, setisChange] = useState(false);
  // const handleClose = () => setShow(false);
  // const handleLockClose = () => setLockModalShow(false);

  let navigate = useNavigate();
  let convertedObj;

  let ActiveHeaders = ['Order No.', 'Order Date', 'Customer', 'Action'];
  let cancelledHeaders = ['Order No.', 'Order Date', 'Customer', 'Total Amount', 'Action'];
//   let deliveredHeaders = ['Order No.', 'Order Date', 'Customer', 'Total Amount', 'Action'];
//   let customerRequestHeaders = ['Request Type', 'Order No.', 'Sub Order No.', 'Customer Name', 'Request Date', 'Request Status', 'Action', ''];
//   let cancelledHeaders = ['Order No.', 'Order Date', 'Customer', 'Total Amount', 'Action'];

  let headersMap = new Map();
  headersMap.set(1, ActiveHeaders);
  headersMap.set(2, cancelledHeaders);
//   headersMap.set(3, deliveredHeaders);
//   headersMap.set(4, customerRequestHeaders);
//   headersMap.set(5, cancelledHeaders);

    let statusArr = [];
    // Dashboard counts
  // useEffect(() => {
  //   const getState = async () => {
  //     const statusResp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/orderscount`, { headers: getHeaders() });
  //     statusResp.data ? console.log(statusResp.data.result.data) : console.log('data');
  //     statusResp.status == 200 ? setStatus(statusResp.data.result.data) : ' ';
  //     console.log(status);
  //   };
  //   getState();
  // }, [refreshPage]);
  // console.log(status);

//   const user = JSON.parse(localStorage.getItem('user'));
//   if (user.userType === 'A') setEditBtn('block');
  const userRequestListingAPI = async (formData) => {
    console.log(formData);
    const partnerResp = await axios.post(`${app.URL}/api/v1/admin/userrequest/view`, formData, { headers: getHeaders() });
    console.log(partnerResp);
    partnerResp ? console.log(partnerResp.data.result.data) : '';
    partnerResp ? (convertedObj = dateConverter(partnerResp.data.result.data.data, 'createdAt')) : ' ';
    partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
    partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
    partnerResp.data.result ? setRenderList(convertedObj) : ' ';
  };

  const getData = async () => {
    let formData = {
      limit: pageSize,
      offset: 0,
      searchBy: '',
      searchTxt: '',
    };
    console.log(formData);
    const partnerResp = await axios.post(`${app.URL}/api/v1/admin/userrequest/view`, formData, { headers: getHeaders() });
    console.log(partnerResp);
    partnerResp ? console.log(partnerResp.data.result.data) : ' ';
    partnerResp.data.result ? (convertedObj = await dateConverter(partnerResp.data.result.data.data, 'createdAt')) : ' ';
    partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
    partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
    partnerResp.data.result ? setRenderList(convertedObj) : ' ';
    return console.log('return called');
  };

  const onPageChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setPageSize(pageSize);
    setCurrentPage(page);
    if (!page) page = 1;
    let limit = pageSize;
    try {
      let reqObj;
      if (Object.keys(searchShow).length !== 0) {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: searchShow.searchBy,
          searchTxt: searchShow.searchTxt,
          filterBy: newFilter?.filterBy,
          filterParam: newFilter?.filterParam
        };
      } else {
        reqObj = {
          limit: limit,
          offset: limit * (page - 1),
          searchBy: 'orderNo.',
          searchTxt: '',
          filterBy: newFilter?.filterBy,
          filterParam: newFilter?.filterParam,
        };
      }
      console.log(reqObj);
      await getInProgressData(reqObj);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.message);
      setTableShow(false);
    }
  };

  //Resend Order Work flow End
  console.log(renderList);

  const getInProgressData = async (formData) => {
    setRenderList([])
    console.log(formData,searchShow,"inprogress");
    setLoader(true);
    setSearchShow(formData);
    console.log('data');
    let isSearch = formData?.searchBy && formData?.searchTxt ? `&searchBy=${formData?.searchBy}&searchTxt=${formData?.searchTxt}` : ``;
    let isFilter = formData?.filterBy && formData?.filterParam ? `&orderBy=${formData?.filterBy}&orderByType=${formData?.filterParam}` : formData?.filterBy ? `&orderBy=${formData?.filterBy}&orderByType=ASC` : '';
    
    // const partnerResp = await axios.get(`${app.URL}/api/v1/admin/subscribe/dashboard?status=${activeIndex == 1 ? 'active' : activeIndex == 2 ? 'canceled' : 'completed'}&limit=${formData?.limit}&offset=${formData?.offset}${isSearch}`, { headers: getHeaders() });
    const partnerResp = await axios.get(`${app.URL}/api/v1/admin/subscribe/dashboard?status=${activeIndex == 1 ? 'active' : activeIndex == 2 ? 'canceled' : 'completed'}&limit=${formData?.limit}&offset=${formData?.offset}${isSearch}${isFilter}`, { headers: getHeaders() });

  

    //   const partnerResp= ressponse
    // const partnerResp = await axios.post(`http://localhost:3200/api/v1/admin/ecomorders/vieworders/2`, formData, { headers: getHeaders() });

    http: console.log('calling again data');
    console.log('partnerResp', partnerResp);
    partnerResp ? console.log(partnerResp.data.result.data) : ' ';
    partnerResp.data.result ? (convertedObj = await dateConverter(partnerResp.data.result.data.data, 'createdAt')) : ' ';
    partnerResp.data.result ? setFetchPartners(convertedObj) : ' ';
    partnerResp.data.result ? setPagesCount(partnerResp.data.result.data.count) : ' ';
    partnerResp.data.result ? setRenderList(convertedObj) : ' ';
    partnerResp.data.result ? setdurationFreq(partnerResp.data.result.data?.durationFrequency) : ' ';
    partnerResp.data.result ? setorderByObj(partnerResp.data.result.data?.orderBy) : ' ';



    partnerResp.data.result && setLoader(false);
    partnerResp.data.result && setRefreshPage(false);

    console.log('return called', partnerResp.data.result.data.displayCount?.activeCount);
    partnerResp.data.result.data.displayCount && setStatus(partnerResp.data.result.data.displayCount);
    return console.log('return called');
  };
console.log("durationFreq",durationFreq)
  useEffect(() => {
    setTableHeaders(headersMap.get(1));
    let formData = {
      limit: pageSize,
      offset: 0,
      searchBy: '',
      searchTxt: '',
    };
    getInProgressData(formData);
  }, [refreshPage]);

  const { Panel } = Collapse;
  const customExpandIcon = (panelProps) => {
    const { isActive } = panelProps;

    return <span>{isActive ? <CaretDownOutlined /> : <CaretRightOutlined />}</span>;
  };
 const mainOrderModal = (order) => {
   console.log('Main Order Modal Running');

   const getData = async (order) => {
    //  const resp = await axios.get(`${app.URL}/api/v1/admin/subscribe/dashboard?status=${activeIndex == 1 ? 'active' : activeIndex == 2 ? 'cancelled' : 'completed'}&limit=10&offset=1&purchaseId=${order.id}`, { headers: getHeaders() });
     const resp = await axios.get(`${app.URL}/api/v1/admin/subscribe/dashboard?status=${activeIndex == 1 ? 'active' : activeIndex == 2 ? 'canceled' : 'completed'}&purchaseId=${order.id}`, { headers: getHeaders() });

       resp && console.log('response', resp);
      resp &&  setSubOrderObj(resp.data.result.data );
    //  setMainOrderObj(resp.data.result.data);
    //  setSingleMainOrderObj(resp.data.result.data);
    //  console.log(order, resp.data.result.data);
    //  openMainOrderModal();
   };
   getData(order);
 };
  const onCollapseChange = async (key) => {
    console.log('Collapse change:', key);
      console.log('Number(key[0])', Number(key[0]));
    // mainOrderModal(order);
        const expandedOrder = renderList.find((order) => order?.id === Number(key[0]));
            console.log('expandedOrder', expandedOrder);

    //   if (expandedOrder) {
    //         console.log("here")
          mainOrderModal(expandedOrder); // ✅ Now you're passing the correct order
        // }
  };
  console.log(subOrderObj);
  const onViewClick = (data) => {
    console.log('onViewClick');
    console.log(data.ecomOrderId);
    localStorage.setItem('orderId', JSON.stringify(data.ecomOrderId));
    navigate('/ecomorders/view', { replace: true });
  };

  const onSearchFinish = async (values) => {
    console.log('onSearchFinish');
    console.log('Success:', values);
    // return
    let formData = {
      limit: 10,
      offset: 0,
      searchBy: values?.searchBy && values.searchBy.charAt(0) == 'S' ? 'SubscriptionNo' : values.searchBy, //partnerName, serialNo, orderNo
      searchTxt: values.searchTxt,
      filterBy: values?.filterBy ? values.filterBy : '',
      filterParam: values?.filterParam ? values.filterParam : '',
      // status: activeIndex, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
      // orderDateFrom: orderDateFrom ? orderDateFrom : '', //2023-03-03  only give date without time
      // orderDateTo: orderDateTo ? orderDateTo : '',
    };
    setnewFilter({ filterBy: values?.filterBy ? values.filterBy : '', filterParam: values?.filterParam ? values.filterParam : '' });
    if (!formData.searchTxt && !formData.filterBy) return message.error('Please enter search text');
    else {
      await getInProgressData(formData);
      setCurrentPage(1);
    }
  };

  const onSearchFinishFailed = (values) => {
    console.log('Failed:', values);
  };

  const onCardViewClick = (data) => {
    console.log("data : ",data)
    if (data == 1) {
      console.log('data inner1 : ', data);

      setActiveIndex(data);
      setRefreshPage(true);
    setCurrentPage(1);

      // navigate('/discount-percentage/view', { replace: true });
    } else if (data == 2) {
      setRefreshPage(true);
      console.log('data inner2 : ', data);

      setActiveIndex(data);
    setCurrentPage(1);

      // navigate('/ecom/dashboard/delivered', { replace: true });
    } else if (data == 3) {
      setRefreshPage(true);
      console.log('data inner3 : ', data);

      setActiveIndex(data);
    setCurrentPage(1);

      // navigate('/ecom/dashboard/delivered', { replace: true });
    }
    // else if (data == 3) {
    //   setActiveIndex(data);
    //   navigate('/ecom/dashboard/delivered', { replace: true });
    // } else if (data == 4) {
    //   setActiveIndex(data);
    //   navigate('/ecom/dashboard/request', { replace: true });
    // } else if (data == 5) {
    //   setActiveIndex(data);
    //   navigate('/ecom/dashboard/cancel', { replace: true });
    // }
  };



  const getMainOrderData = async (id) => {
    try {
      let resp = await axios.get(`${app.URL}/api/v1/admin/ecomorders/view/${id}`, { headers: getHeaders() });
      // let resp = await axios.get(`http://localhost:3200/api/v1/admin/ecomorders/view/${id}`, { headers: getHeaders() });

      // console.log("main order get api response: ", resp.data.result.data );
      // setSingleMainOrderObj(resp.data.result.data);
      // setSubOrderObj(resp.data.result.data);

      // console.log("sub order obj modal api before: ", subOrderObj);
      // console.log("main order single obj modal api before: ", singleMainOrderOBj);

    //   setSingleMainOrderObj(resp.data.result.data);

    //   console.log('main order obj: ', singleMainOrderOBj);

        setIsModalLoading(!isModalLoading);
         setMainOrderObj(resp.data.result.data);
         setSingleMainOrderObj(resp.data.result.data);
        //  console.log(order, resp.data.result.data);
         openMainOrderModal();

      // console.log("sub order obj modal api after: ", subOrderObj);
      // console.log("main order single obj modal api after: ", singleMainOrderOBj);
    } catch (error) {
      console.log('Error: ', error);
    }
  };
  const mainViewClicked = (order) => {
    console.log('clicked');
    setismainView(true);
    setmainModalData(order);
  };
  const genExtra = (order) => (
    <table className='w-100'>
      <tbody>
        <tr>
          {/* <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {order.name}
          </td> */}
          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {order.subscriptionNo}
          </td>
          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {order.durationName}
          </td>
          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {order.frequencyName}
          </td>

          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {/* category per frequency */}
            {order.quantity}
          </td>
          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {Number(order.addOnScans) + Number(order.facialScans)}
          </td>
          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {order.amount}
          </td>
          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {/* {order.createdAt} */}
            {localDate(order.createdAt)}
          </td>
          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {/* {order.createdAt} */}
            {localDate(order.startDate)}
          </td>
          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            {/* {order.createdAt} */}
            {localDate(order.endDate)}
          </td>

          <td
            className='text-center'
            style={{
              width: '10%',
            }}
          >
            <Button
              onClick={() => {
                // getMainOrderData(order.ecomOrderId);
                // mainOrderModal(order);
                mainViewClicked(order);
              }}
              style={{ width: '80px', height: '34px', fontSize: 'small' }}
              size='small'
            >
              View
            </Button>
          </td>
        </tr>
      </tbody>
    </table>
  );

  const [mainOrderObj, setMainOrderObj] = useState({});
 
 

  const handleOnChange = (e) => {
    console.log("e is :",e)
    if (e.target.value.length === 0) {
      setRefreshPage(!refreshPage);
      setSearchShow({});
    }
  };

  const openMainOrderModal = () => {
    setShowSingleMainOrder(true);
  };

  console.log(subOrderObj);
//   useEffect(() => {
//     let resp;
//     Object.keys(subOrderObj).length > 0 ? (resp = subOrderObj.address.filter((ele) => ele.requestId)) : '';
//     console.log(resp);
//     resp && resp.length > 0 ? setIsCustomerRequest(true) : setIsCustomerRequest(false);
//   }, [subOrderObj]);

  console.log(isCustomerRequest);
  let searchItems = [
    {
      name: 'Subscription No.',
      value: 'subscriptionNo',
    },
    {
      name: 'Duration',
      value: 'duration',
    },
  ];

  console.log('singleOrderOBjsingleOrderOBj', singleOrderOBj);

  const durationSelect = async (value) => {
    console.log('value ', value);
    durationSelection(getInProgressData, value, setorderDateFrom, setorderDateTo, activeIndex, searchShow, 10, 0, 'productName');
  };
  const onChange = async (date, dateString) => {
    console.log(date, dateString);
    onChangeMethod(getInProgressData, dateString, setorderDateFrom, setorderDateTo, activeIndex, searchShow, pageSize, pageSize * (currentPage - 1), 'productName');
  };

  console.log('showSingleMainOrdershowSingleMainOrder', showSingleMainOrder);

  return (
    <div className='dashboard-card container-fluid'>
      <EcomDashboardHeader title='Subsbcription Dashboard' isSubscription={true} />
      <SubsDashboardCard status={status} onCardViewClick={onCardViewClick} activeIndex={activeIndex} />
      {/* <SearchBar onFinish={onSearchFinish} onFinishFailed={onSearchFinishFailed} searchItems={searchItems} onChange={handleOnChange} /> */}
      {/* {renderList.length > 0 && */}
      <SearchBar onFinish={onSearchFinish} onFinishFailed={onSearchFinishFailed} searchItems={searchItems} onChange={handleOnChange} isFilter={true} activeIndex={activeIndex} setSearchShow={setSearchShow} setCurrentPage={setCurrentPage} setfilterObj={setfilterObj} durationFreq={durationFreq} isSubscription={true} orderByObj={orderByObj} />
      {/* } */}
      {/* <div className='row px-3'>
        
        <div style={{ position: 'relative' }} className='col-md-4 col-12 my-1' onClick={() => onCardViewClick(1)}>
          <EcommerceDashboardCard count={status.length > 1 ? status[1].count : 0} isActive={window.location.pathname == '/ecom/dashboard/inprogress' || window.location.pathname == '/ecom/dashboard'} activatedProducts={true} awaitingProducts={false} cardName={'In Progress'} />
        </div>
        <div style={{ position: 'relative' }} className='col-lg-2 mb-4' onClick={() => onCardViewClick(2)}>
          <EcommerceDashboardCard count={status.length > 1 ? status[2].count : 0} isActive={window.location.pathname == '/ecom/dashboard/intransit'} activatedProducts={true} awaitingProducts={false} cardName={'In Transit'} />
        </div>
        <div style={{ position: 'relative' }} className='col-lg-2 mb-4' onClick={() => onCardViewClick(3)}>
          <EcommerceDashboardCard count={status.length > 1 ? status[3].count : 0} isActive={window.location.pathname == '/ecom/dashboard/delivered'} activatedProducts={false} awaitingProducts={true} cardName={'Delivered'} />
        </div>
        <div style={{ position: 'relative', maxHeight: '150px' }} className='col-lg-2 mb-4' onClick={() => onCardViewClick(4)}>
          <EcommerceDashboardCard count={status.length > 1 ? status[status.length - 1].requestCount : 0} isActive={window.location.pathname == '/ecom/dashboard/request'} activatedProducts={false} awaitingProducts={false} cardName={'Request'} />
        </div>
        <div style={{ position: 'relative' }} className='col-lg-2 mb-4' onClick={() => onCardViewClick(5)}>
          <EcommerceDashboardCard count={status.length > 1 ? status[4].count : 0} isActive={window.location.pathname == '/ecom/dashboard/cancel'} activatedProducts={false} awaitingProducts={false} cardName={'Cancelled/Refund'} />
        </div>
      </div> */}
      {/* orders table to copy*/}
      {loader && <LoaderImage />}
      {renderList.length > 0 && !loader ? (
        <div className='row table-scrollbar '>
          <table
            id='customers'
            // style={{
            //   padding: '5px 0px',
            // }}
          >
            <thead>
              <tr>
                {['Subscription No.', 'Duration', 'Frequency', 'Product quantity', 'Total scans', 'Amount', 'Created Date', 'Start Date', 'End Date', 'Action'].map((item) => (
                  <th key={item} style={{ fontWeight: 'bold', width: '10%' }}>
                    {item}
                  </th>
                ))}
              </tr>
            </thead>
          </table>
          <div>
            <Collapse accordion obClexpandIcon={customExpandIcon} onChange={onCollapseChange}>
              {renderList.map((order, index) => (
                <Panel
                  onClick={(e) => {
                    e.stopPropagation();
                    // setSubOrderObj(order);
                  }}
                  header={genExtra(order)}
                  key={order.id}
                  className='table-scrollbar '
                >
                  {Object.keys(subOrderObj).length > 0 ? (
                    <table id='customers' className=' w-100'>
                      {/* <thead>
                        <tr
                          style={{
                            fontWeight: 'bold',
                          }}
                        >
                          <th>Sub Order No.</th>
                          <th>Address</th>
                          <th>Total</th>
                          <th>Grand Total</th>
                          <th>Status</th>
                          {isCustomerRequest && <th>Customer Request</th>}
                          <th>Action</th>
                          <th></th>
                        </tr>
                      </thead> */}

                      <thead>
                        <tr
                          style={{
                            fontWeight: 'bold',
                          }}
                        >
                          <th>Order No.</th>
                          <th>Order Date</th>
                          {/* <th>Customer</th> */}
                          {/* <th>Grand Total</th> */}
                          {/* <th>Address</th> */}
                          {/* {isCustomerRequest && <th>Customer Request</th>} */}
                          <th>Action</th>
                          <th></th>
                        </tr>
                      </thead>

                      {Array.isArray(subOrderObj) && subOrderObj.length > 0 && (
                        <tbody>
                          {subOrderObj.map((ele, idx) =>
                            ele.ecomOrderId && ele.addressId ? (
                              <tr key={idx}>
                                <td>{ele.ecomOrderNo}</td>
                                <td>
                                  {localDate(ele.orderDate )}
                                </td>
                                {/* <td>{ele.address}</td> */}
                                <td>
                                  <Button onClick={() => getMainOrderData(ele.ecomOrderId)} style={{ width: '70px', height: '34px', fontSize: 'small', margin: '0px 10px' }} size='medium'>
                                    View
                                  </Button>
                                </td>
                              </tr>
                            ) : null
                          )}
                        </tbody>
                      )}
                    </table>
                  ) : (
                    <div className=' text-center'>
                      <span>
                        {' '}
                        <Space size='middle'>
                          <Spin size='large' />
                        </Space>
                      </span>
                    </div>
                  )}
                </Panel>
              ))}
            </Collapse>
          </div>
        </div>
      ) : (
        <>{!loader && <NoDataFound />}</>
      )}
      {/* {currentPage && pagesCount ? <Pagination style={{ marginTop: '10px' }} onChange={activeIndex == 4 ? onRequestChange : onPageChange} defaultCurrent={currentPage} total={pagesCount} showTotal={(total) => `Total ${total} items`} showSizeChanger /> : ' '} */}

      {currentPage && pagesCount && renderList.length > 0 ? <Pagination style={{ marginBottom: '20px' }} onChange={onPageChange} defaultCurrent='1' current={currentPage} total={pagesCount} showTotal={(total) => `Total ${total} items`} showSizeChanger /> : ''}
      {/* show single main order modal start */}
      {/* onview this is calling */}
      {showSingleMainOrder && (
        <MainOrderViewModal
          // singleMainOrderOBj={singleMainOrderOBj}
          isVisible={showSingleMainOrder}
          setIsVisible={setShowSingleMainOrder}
          ecomOrderId={singleMainOrderOBj.ecomOrderId}
          ecomOrderNo={singleMainOrderOBj.ecomOrderNo}
          ecomOrderCreatedData={localDate(singleMainOrderOBj.createdAt)}
          // patientName={"singleMainOrderOBj.patientName"}
          productTotalAmount={singleMainOrderOBj.totalProductAmount}
          shipmentTotal={singleMainOrderOBj.totalShipmentCharges}
          subOrdersData={singleMainOrderOBj?.orderDetails}
          isLoading={isModalLoading}
          setIsLoading={setIsModalLoading}
          mainOrderShipmentAmount={singleMainOrderOBj.totalShipmentCharges}
          mainOrderGrandTotal={singleMainOrderOBj.grandTotalAmount}
          totalProductAmount={singleMainOrderOBj.totalProductAmount}
          isApiCallAble={false}
          last4={singleMainOrderOBj?.last4}
        />
      )}
      {ismainView && (
        <SubsMainModal
          isVisible={ismainView}
          setIsVisible={setismainView}
          packageType={mainModalData?.packageType}
          subscriptionNo={mainModalData?.subscriptionNo}
          subscriptionName={mainModalData?.name}
          duration={mainModalData?.durationName}
          frequency={mainModalData.frequencyName}
          productCategory={mainModalData.productCategory} //
          products={mainModalData.productNames} //
          productQuantity={mainModalData.quantity}
          facialScans={mainModalData.facialScans} //
          addonFacialScans={mainModalData.addOnScans} //
          amount={mainModalData.amount}
          subscriptionCreatedDate={moment(mainModalData.createdAt).format('MM-DD-YYYY')}
          subscriptionStartDate={moment(mainModalData.startDate).format('MM-DD-YYYY')}
          subscriptionEndDate={moment(mainModalData.endDate).format('MM-DD-YYYY')}
          status={mainModalData?.statusName}
        />
      )}
      {/* show single main order modal end */}
      {/* show single sub order modal start */}

      {/* 


      <SubOrderViewModal
        isVisible={showSingleOrder}
        ecomOrderNo={`${subOrderObj.ecomOrderNo}-${singleOrderOBj.addressId}`}
        setIsVisible={setShowSingleOrder}
        address={`${singleOrderOBj.address}, ${singleOrderOBj.state}, ${singleOrderOBj.city}, ${singleOrderOBj.zipCode}`}
        ecomOrderCreatedDate={localDate(subOrderObj.createdAt)}
        productsData={singleOrderOBj?.products}
        status={singleOrderOBj.status}
        title={singleOrderOBj.title}
        shipmentCharges={singleOrderOBj.shipmentCharges}
        grandTotal={singleOrderOBj.totalAmountwithShipment}
        totalShipmentAmount={singleOrderOBj.totalShipmentAmount}
        tax={singleOrderOBj.taxAmount}
        requestId={singleOrderOBj.requestId}
        requestStatus={singleOrderOBj.requestStatus}
        requestType={singleOrderOBj.requestType}
        shipmePackageName={singleOrderOBj.shipmePackageName}
        addressId={singleOrderOBj.addressId}
        ecomOrderId={subOrderObj.ecomOrderId}
        isApiCall={true}
        locationURL={window.location.pathname}
        wareHouseStatus={singleOrderOBj.wareHouseStatus}
        contactPerson={singleOrderOBj?.contactPerson}
        mobile={singleOrderOBj?.mobile}
        last4={singleOrderOBj?.last4}
      />




 */}

      {/* show single sub order modal end */}
      {/* dispatch order modal start */}
    </div>
  );
};

export default SubsDashboard;







//  

//  {subOrderObj?.map((ele) => (
//                         //<div className='mb-2'>
//                         <tbody>
//                           <tr>
//                             <td style={{}}>{ele.ecomOrderNo}</td>
//                             <td style={{}}>{ele.title ? ele.title : ''}</td>

//                             {/* <td style={{ width: '250px' }}>{`${ele.address}, ${ele.state}, ${ele.city}, ${ele.zipCode}`}</td> */}
//                             <td style={{}}>{ele.address}</td>
//                             {/* <td style={{ width: '150px' }}>${(ele.totalAmountwithShipment + ele.taxAmount)?.toFixed(2)}</td> */}
//                             {/* {isCustomerRequest ? <td style={{ width: '150px' }}>{ele.requestId ? ele.requestType : 'None'}</td> : ''} */}
//                             {/* {(ele.requestStatus === 'Reject' || !ele.requestStatus) && !ele.wareHouseStatus && ( */}
//                             {/* <td style={{ width: '150px' }}>
//                                 <Button
//                                   onClick={() => {
//                                     onPrepareShimentTrigger(ele);
//                                   }}
//                                   style={{ width: '180px', height: '34px', fontSize: 'small', marginRight: '0px' }}
//                                   size='medium'
//                                 >
//                                   Send to Warehouse
//                                 </Button>
//                               </td>
//                             )} */}
//                             {/* {ele.ecomOrderId && ele.addressId && ( */}
//                               <td>
//                                 <Button
//                                   onClick={() => {
//                                     // openMainOrderModal();
//                                     getMainOrderData(ele.ecomOrderId);
//                                     //   setSingleOrderObj(ele);
//                                     //   setShowSingleOrder(true);
//                                   }}
//                                   style={{ width: '70px', height: '34px', fontSize: 'small', margin: '0px 10px' }}
//                                   size='medium'
//                                 >
//                                   View
//                                 </Button>
//                               </td>
//                             {/* // )} */}
//                           </tr>
//                         </tbody>

//                         // </div>
//  ))
// }
                      

